// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const env = (window as any).env;

export const environment: any = {
    production: true,
    envName: env?.envName || 'production',
    serviceApi: env?.serviceApi || 'https://api.fisconly.com.br',
};